export default __webpack_public_path__ + "static/media/emc-2.fab980ed.png";